import { render, staticRenderFns } from "./BetGameInfo.vue?vue&type=template&id=1669871b&scoped=true&"
import script from "./BetGameInfo.vue?vue&type=script&lang=js&"
export * from "./BetGameInfo.vue?vue&type=script&lang=js&"
import style0 from "./BetGameInfo.vue?vue&type=style&index=0&id=1669871b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1669871b",
  null
  
)

export default component.exports